import { useMemo } from 'react';
import $window from './window';
import parseJSON from './parse-json';

export function getValueFromDigitalData(key, digitalData) {
  return digitalData?.export()?.flag?.[key];
}

export function getOverridesFromLocationSearch(locationSearch) {
  if (locationSearch) {
    const ldoField = locationSearch.match(/ldo=(.+)&?/);
    const ldoFieldValue = (ldoField && ldoField[0]);
    const ldoFieldValueDecoded = decodeURIComponent(ldoFieldValue);
    const modeField = ldoFieldValueDecoded.match(/ldo=(([\w-0-9]+:[01],?)+)&?/);
    const modeFieldValue = (modeField && modeField[1]);
    if (modeFieldValue) {
      const modeFields = modeFieldValue.split(',');
      const overrides = modeFields.reduce((accum, override) => {
        const parts = override?.split(':');
        const data = {};
        data[parts[0]] = parseInt(parts[1], 10);
        return { ...accum, ...data };
      }, {});
      return overrides;
    }
  }
  return {};
}

function getLocalStorageOverrides() {
  const ldo = $window?.localStorage?.getItem('ldo');
  return parseJSON(ldo, {});
}

export function getDigitalDataFlagValue(key, overrides, digitalData, defaultValue) {
  if (overrides && typeof overrides === 'object' && key in overrides) {
    return overrides[key];
  }
  const value = getValueFromDigitalData(key, digitalData);
  if (value === undefined) {
    return defaultValue;
  }
  return value;
}

export function getOverrides(locationSearch) {
  return [
    getLocalStorageOverrides(),
    getOverridesFromLocationSearch(locationSearch),
  ].reduce((accum, override) => ({ ...accum, ...override }), {})
}

export function useGetDigitalDataFlagValue(key, defaultValue) {
  const locationSearch = useMemo(() => $window?.location?.search, []);
  const overrides = useMemo(() => getOverrides(locationSearch), [locationSearch]);
  return useMemo(
    () => getDigitalDataFlagValue(key, overrides, $window?.digitalData, defaultValue),
    [key, overrides, defaultValue],
  );
}
